import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/corridas`, options).then(response => {
    return {
      list: response.data.data, 
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/corridas/${id}`, options)
    .then(response => {
      let corrida = jsona.deserialize(response.data);
      delete corrida.links;
      return corrida;
    });
}

function add(corrida) {
  const payload = jsona.serialize({
    stuff: corrida,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/corridas`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(corrida) {
  const payload = jsona.serialize({
    stuff: corrida,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .patch(`${url}/corridas/${corrida.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function actualiza(corrida) {
  const payload = jsona.serialize({
    stuff: corrida,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .put(`${url}/corridas/${corrida.id}/actualizaCorrida`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function validate(corrida) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  let urlParams = `${url}/validarCorridas?ruta_id=${corrida.ruta_id}&fecha_inicio=${corrida.fecha_inicio}&fecha_fin=${corrida.fecha_fin}&hora_salida=${corrida.hora_salida}`;
  
  if (corrida.layout_id) {
    urlParams += `&layout_id=${corrida.layout_id}`;
  }

  return axios
    .get(urlParams, options)
    .then(response => {
      let corrida = response.data;
      return corrida;
    });
}

function listTramosSubcorridas(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/corridas/listaTramosSubcorridas/${id}`, options)
    .then(response => {
      return response.data.data;
    });
}

function listAbordaje(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/corridas/listaDeAbordaje/${id}`, options)
    .then(response => {
      return response.data.data;
    });
}

function activate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/corridas/activate/${id}`, options);
}

function deactivate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/corridas/deactivate/${id}`, options);
}

function layoutCorrida(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/corridas/infoCambioLayoutCorrida/${id}`, options)
    .then(response => {
      return response.data.data;
    });
}

function updateLayout(corrida) {
  const payload = jsona.serialize({
    stuff: corrida,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/corridas/actualizaLayout`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function getCorridasOrigen() {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/canjeMasivo/subcorridasOrigen?page[number]=1&page[size]=100000000`, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function getCorridasDestino(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/canjeMasivo/subcorridasDestino?page[number]=1&page[size]=100000000&corrida_origen_id=${data.corrida_id}&es_limbo=${data.es_limbo}`, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function getInfoCanje(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/canjeMasivo/obtenerInfoCanje?ruta_id=${data.ruta_id}&corrida_id=${data.corrida_id}&es_limbo=${data.es_limbo}`, options)
    .then(response => {
      if(data.es_limbo === 0){
        return response.data;
      }else{
        return response.data.data.attributes.asientos;
      }
      
    });
}

function getRutasConLimbos() {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/canjeMasivo/rutasConLimbos?page[number]=1&page[size]=100000000`, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function canjearAsiento(asiento) {
  const payload = jsona.serialize({
    stuff: asiento,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/canjeMasivo/canjear`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function getGrupoCorridas(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/corridas/infoGrupoCorridas/${id}`, options)
    .then(response => {
        return response.data.data;
    });
}

function addSubcorridas(subcorridas) {
  const payload = jsona.serialize({
    stuff: subcorridas,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/grupo_corridas/crearSubcorridas`, payload, options)
    .then(response => {
      return response.data;
    });
}

function getTotalVentaCorrida(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/corridas/totalVenta/${id}`, options)
    .then(response => {
        return response.data;
    });
}

function destroy(id, confirm = false) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    },
    params: {
      ...(confirm ? { confirm: true } : {})
    }
  };

  return axios.delete(`${url}/corridas/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  actualiza,
  validate,
  listTramosSubcorridas,
  listAbordaje,
  activate,
  deactivate,
  layoutCorrida,
  updateLayout,
  getCorridasOrigen,
  getCorridasDestino,
  getInfoCanje,
  canjearAsiento,
  getRutasConLimbos,
  getGrupoCorridas,
  addSubcorridas,
  getTotalVentaCorrida,
  destroy
};
